export enum RibStatut {
	EnAttenteEnregistrementParAvocat = 'enAttenteEnregistrementParAvocat',
	EnAttenteEnregistrementParCarpa = 'enAttenteEnregistrementParCarpa',
	Enregistre = 'enregistre'
}
